import React from 'react';
import { Navigations } from '@navigation';
import { AppContextProvider } from '@database/contexts';


const App: React.FC = () => {
  return (
    <AppContextProvider>
      <Navigations />
    </AppContextProvider>
  );
}

export default App;
